// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-wrapper {
    max-width: 1200px;
    margin: 2rem auto;
    background: var(--clr-grey-7);
    border: 2px solid var(--clr-primary-3);
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    overflow: hidden;
  }
  
  .pat-timeline-container {
    padding: 2rem 2rem 2rem;
    background: var(--clr-grey-9);
  }
  
  .pat-timeline-container.no-border {
    border: none;
    border-top: 0;
    box-shadow: none;
    margin: 0;
  }

  .timeline-info-box-flex {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
    max-width: 1200px;
    margin: 2rem auto 1.5rem;
    padding: 1.75rem 2rem;
    background: var(--clr-white);
    border: 1px solid var(--clr-grey-7);
    border-left: 6px solid var(--clr-primary-6);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    animation: fadeIn 0.3s ease-in-out;
    flex-wrap: wrap;
  }
  
  .patient-contact-card {
    flex: 1 1 20%;
    background: var(--clr-grey-10);
    border: 1px solid var(--clr-grey-7);
    border-radius: var(--radius);
    padding: 1rem;
    font-size: 0.95rem;
    color: var(--clr-grey-3);
    box-shadow: var(--shadow-1);
  }
  
  .patient-contact-card h4 {
    font-size: 1.05rem;
    color: var(--clr-primary-6);
    margin-bottom: 0.5rem;
  }
  
  .patient-contact-card p {
    font-size: 1rem;
    color: var(--clr-grey-2);
    margin-bottom: 0.5rem;
  }
  .timeline-info-main {
    flex: 1 1 75%;
  }
  
  
  .timeline-info-box {
    max-width: 850px;
    margin: 2rem auto 1.5rem;
    padding: 1.75rem 2rem;
    background: var(--clr-white);
    border: 1px solid var(--clr-grey-7);
    border-left: 6px solid var(--clr-primary-6);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    animation: fadeIn 0.3s ease-in-out;
  }
  
  .timeline-title {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: var(--clr-primary-5);
  }
  
  .timeline-description {
    font-size: 1.05rem;
    line-height: 1.7;
    color: var(--clr-grey-1);
  }
  
  
  .pat-timeline-list {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    margin-bottom: 2rem;
    padding-left: 0.5rem;
  }
  
  .timeline-row-pat {
    display: flex;
    align-items: stretch;
    gap: 1.75rem;
    position: relative;
  }
  
  .timeline-marker-pat {
    width: 30px;
    /* position: relative; */
  }
  
  .timeline-dot-wrapper {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    width: 100%;
    z-index: 2;
  }
  
  .timeline-dot-pat {
    width: 16px;
    height: 16px;
    background-color: var(--clr-white);
    border: 4px solid var(--clr-primary-6);
    border-radius: 50%;
    z-index: 3;
    box-shadow: 0 0 0 3px var(--clr-primary-3), 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
  }
  
  .timeline-horizontal-line-pat {
    width: 28px;
    height: 2px;
    background: linear-gradient(to right, var(--clr-primary-2), var(--clr-primary-3));
    margin-left: 8px;
    border-radius: 4px;
    box-shadow: 0 0 2px var(--clr-primary-6);
    z-index: 1;
  }
  
  .timeline-line-pat {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 8px; 
    width: 2px;
    background: linear-gradient(to bottom, var(--clr-grey-1), var(--clr-grey-2));
    opacity: 0.7;
    z-index: 0;
  }
  
  
  .pat-pagination {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 1rem;
  }
  
  .pat-pagination-btn {
    padding: 0.4rem 0.8rem;
    border: 1px solid var(--clr-grey-7);
    background: var(--clr-white);
    border-radius: var(--radius);
    cursor: pointer;
    font-weight: 500;
    color: var(--clr-grey-2);
    transition: var(--transition);
  }
  
  .pat-pagination-btn:hover:not(.active):not(:disabled) {
    background-color: var(--clr-primary-10);
    border-color: var(--clr-primary-5);
  }
  
  .pat-pagination-btn.active {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border-color: var(--clr-primary-5);
  }
  
  .pat-pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .timeline-status-pat {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 220px;
    text-align: center;
    gap: 1rem;
  }
  
  .timeline-spinner-pat {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 4px solid transparent;
    border-top: 4px solid var(--clr-primary-5);
    border-left: 4px solid var(--clr-grey-5);
    animation: spin 0.75s linear infinite;
    background: conic-gradient(from 0deg, var(--clr-primary-5), var(--clr-grey-5));
    mask-image: radial-gradient(circle, white 65%, transparent 66%);
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  .timeline-loading-text {
    font-size: 1rem;
    font-weight: 500;
    color: var(--clr-grey-4);
  }
  
  .timeline-message.error {
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--clr-red-dark);
  }
  
  /*Responsive Styles */

@media (max-width: 1024px) {
    .timeline-info-box {
      margin: 1.5rem 1rem;
      padding: 1.5rem;
    }
  
    .pat-timeline-container {
      padding: 1.5rem 1rem;
    }
  
    .timeline-title {
      font-size: 1.5rem;
    }
  
    .timeline-description {
      font-size: 1rem;
    }
  
    .timeline-row-pat {
      gap: 1.25rem;
    }
  }
  
  @media (max-width: 768px) {
    .timeline-info-box {
      padding: 1.25rem;
    }
  
    .pat-timeline-list {
      gap: 2rem;
      padding-left: 0;
    }
  
    .timeline-row-pat {
      flex-direction: column;
      gap: 1rem;
    }
  
    .timeline-dot-wrapper {
      position: relative;
      transform: none;
      margin-bottom: 0.5rem;
    }
  
    .timeline-horizontal-line-pat {
      display: none;
    }
  
    .timeline-line-pat {
      display: none;
    }
  
    .timeline-marker-pat {
      width: auto;
    }
  
    .timeline-status-pat {
      padding: 2rem 1rem;
    }
  
    .timeline-loading-text {
      font-size: 0.95rem;
      text-align: center;
    }
  }
  
  @media (max-width: 1024px) {
    .timeline-info-box-flex {
      flex-direction: column;
      gap: 1.5rem;
      padding: 1.5rem;
    }
  
    .patient-contact-card,
    .timeline-info-main {
      flex: 1 1 100%;
    }
  
    .patient-contact-card {
      font-size: 0.95rem;
      padding: 0.9rem;
    }
  
    .patient-contact-card h4 {
      font-size: 1rem;
    }
  
    .patient-contact-card p {
      font-size: 0.95rem;
    }
  
    .timeline-info-main .timeline-title {
      font-size: 1.5rem;
    }
  
    .timeline-info-main .timeline-description {
      font-size: 1rem;
    }
  }
  
  @media (max-width: 480px) {
    .timeline-info-box-flex {
      padding: 1rem 0.75rem;
    }
  
    .patient-contact-card {
      padding: 0.75rem;
      font-size: 0.9rem;
    }
  
    .patient-contact-card h4 {
      font-size: 0.95rem;
    }
  
    .patient-contact-card p {
      font-size: 0.9rem;
    }
  
    .timeline-info-main .timeline-title {
      font-size: 1.25rem;
    }
  
    .timeline-info-main .timeline-description {
      font-size: 0.95rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/PatientTimeline/PatientTimeline.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;IAC7B,sCAAsC;IACtC,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,4BAA4B;IAC5B,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,2BAA2B;IAC3B,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mCAAmC;IACnC,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;;EAGA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,4BAA4B;IAC5B,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;EAC1B;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,sCAAsC;IACtC,kBAAkB;IAClB,UAAU;IACV,yEAAyE;IACzE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,iFAAiF;IACjF,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,SAAS;IACT,UAAU;IACV,4EAA4E;IAC5E,YAAY;IACZ,UAAU;EACZ;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,4BAA4B;IAC5B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,uCAAuC;IACvC,kCAAkC;EACpC;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,0CAA0C;IAC1C,wCAAwC;IACxC,qCAAqC;IACrC,8EAA8E;IAC9E,+DAA+D;EACjE;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA,qBAAqB;;AAEvB;IACI;MACE,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,SAAS;MACT,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,WAAW;MACX,eAAe;IACjB;;IAEA;;MAEE,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".timeline-wrapper {\n    max-width: 1200px;\n    margin: 2rem auto;\n    background: var(--clr-grey-7);\n    border: 2px solid var(--clr-primary-3);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    overflow: hidden;\n  }\n  \n  .pat-timeline-container {\n    padding: 2rem 2rem 2rem;\n    background: var(--clr-grey-9);\n  }\n  \n  .pat-timeline-container.no-border {\n    border: none;\n    border-top: 0;\n    box-shadow: none;\n    margin: 0;\n  }\n\n  .timeline-info-box-flex {\n    display: flex;\n    gap: 2rem;\n    align-items: flex-start;\n    max-width: 1200px;\n    margin: 2rem auto 1.5rem;\n    padding: 1.75rem 2rem;\n    background: var(--clr-white);\n    border: 1px solid var(--clr-grey-7);\n    border-left: 6px solid var(--clr-primary-6);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    animation: fadeIn 0.3s ease-in-out;\n    flex-wrap: wrap;\n  }\n  \n  .patient-contact-card {\n    flex: 1 1 20%;\n    background: var(--clr-grey-10);\n    border: 1px solid var(--clr-grey-7);\n    border-radius: var(--radius);\n    padding: 1rem;\n    font-size: 0.95rem;\n    color: var(--clr-grey-3);\n    box-shadow: var(--shadow-1);\n  }\n  \n  .patient-contact-card h4 {\n    font-size: 1.05rem;\n    color: var(--clr-primary-6);\n    margin-bottom: 0.5rem;\n  }\n  \n  .patient-contact-card p {\n    font-size: 1rem;\n    color: var(--clr-grey-2);\n    margin-bottom: 0.5rem;\n  }\n  .timeline-info-main {\n    flex: 1 1 75%;\n  }\n  \n  \n  .timeline-info-box {\n    max-width: 850px;\n    margin: 2rem auto 1.5rem;\n    padding: 1.75rem 2rem;\n    background: var(--clr-white);\n    border: 1px solid var(--clr-grey-7);\n    border-left: 6px solid var(--clr-primary-6);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  .timeline-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin-bottom: 0.75rem;\n    color: var(--clr-primary-5);\n  }\n  \n  .timeline-description {\n    font-size: 1.05rem;\n    line-height: 1.7;\n    color: var(--clr-grey-1);\n  }\n  \n  \n  .pat-timeline-list {\n    display: flex;\n    flex-direction: column;\n    gap: 3rem;\n    margin-bottom: 2rem;\n    padding-left: 0.5rem;\n  }\n  \n  .timeline-row-pat {\n    display: flex;\n    align-items: stretch;\n    gap: 1.75rem;\n    position: relative;\n  }\n  \n  .timeline-marker-pat {\n    width: 30px;\n    /* position: relative; */\n  }\n  \n  .timeline-dot-wrapper {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    width: 100%;\n    z-index: 2;\n  }\n  \n  .timeline-dot-pat {\n    width: 16px;\n    height: 16px;\n    background-color: var(--clr-white);\n    border: 4px solid var(--clr-primary-6);\n    border-radius: 50%;\n    z-index: 3;\n    box-shadow: 0 0 0 3px var(--clr-primary-3), 0 2px 6px rgba(0, 0, 0, 0.15);\n    transition: all 0.3s ease;\n  }\n  \n  .timeline-horizontal-line-pat {\n    width: 28px;\n    height: 2px;\n    background: linear-gradient(to right, var(--clr-primary-2), var(--clr-primary-3));\n    margin-left: 8px;\n    border-radius: 4px;\n    box-shadow: 0 0 2px var(--clr-primary-6);\n    z-index: 1;\n  }\n  \n  .timeline-line-pat {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 8px; \n    width: 2px;\n    background: linear-gradient(to bottom, var(--clr-grey-1), var(--clr-grey-2));\n    opacity: 0.7;\n    z-index: 0;\n  }\n  \n  \n  .pat-pagination {\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-top: 1rem;\n  }\n  \n  .pat-pagination-btn {\n    padding: 0.4rem 0.8rem;\n    border: 1px solid var(--clr-grey-7);\n    background: var(--clr-white);\n    border-radius: var(--radius);\n    cursor: pointer;\n    font-weight: 500;\n    color: var(--clr-grey-2);\n    transition: var(--transition);\n  }\n  \n  .pat-pagination-btn:hover:not(.active):not(:disabled) {\n    background-color: var(--clr-primary-10);\n    border-color: var(--clr-primary-5);\n  }\n  \n  .pat-pagination-btn.active {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border-color: var(--clr-primary-5);\n  }\n  \n  .pat-pagination-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .timeline-status-pat {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 220px;\n    text-align: center;\n    gap: 1rem;\n  }\n  \n  .timeline-spinner-pat {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    border: 4px solid transparent;\n    border-top: 4px solid var(--clr-primary-5);\n    border-left: 4px solid var(--clr-grey-5);\n    animation: spin 0.75s linear infinite;\n    background: conic-gradient(from 0deg, var(--clr-primary-5), var(--clr-grey-5));\n    mask-image: radial-gradient(circle, white 65%, transparent 66%);\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .timeline-loading-text {\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--clr-grey-4);\n  }\n  \n  .timeline-message.error {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: var(--clr-red-dark);\n  }\n  \n  /*Responsive Styles */\n\n@media (max-width: 1024px) {\n    .timeline-info-box {\n      margin: 1.5rem 1rem;\n      padding: 1.5rem;\n    }\n  \n    .pat-timeline-container {\n      padding: 1.5rem 1rem;\n    }\n  \n    .timeline-title {\n      font-size: 1.5rem;\n    }\n  \n    .timeline-description {\n      font-size: 1rem;\n    }\n  \n    .timeline-row-pat {\n      gap: 1.25rem;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .timeline-info-box {\n      padding: 1.25rem;\n    }\n  \n    .pat-timeline-list {\n      gap: 2rem;\n      padding-left: 0;\n    }\n  \n    .timeline-row-pat {\n      flex-direction: column;\n      gap: 1rem;\n    }\n  \n    .timeline-dot-wrapper {\n      position: relative;\n      transform: none;\n      margin-bottom: 0.5rem;\n    }\n  \n    .timeline-horizontal-line-pat {\n      display: none;\n    }\n  \n    .timeline-line-pat {\n      display: none;\n    }\n  \n    .timeline-marker-pat {\n      width: auto;\n    }\n  \n    .timeline-status-pat {\n      padding: 2rem 1rem;\n    }\n  \n    .timeline-loading-text {\n      font-size: 0.95rem;\n      text-align: center;\n    }\n  }\n  \n  @media (max-width: 1024px) {\n    .timeline-info-box-flex {\n      flex-direction: column;\n      gap: 1.5rem;\n      padding: 1.5rem;\n    }\n  \n    .patient-contact-card,\n    .timeline-info-main {\n      flex: 1 1 100%;\n    }\n  \n    .patient-contact-card {\n      font-size: 0.95rem;\n      padding: 0.9rem;\n    }\n  \n    .patient-contact-card h4 {\n      font-size: 1rem;\n    }\n  \n    .patient-contact-card p {\n      font-size: 0.95rem;\n    }\n  \n    .timeline-info-main .timeline-title {\n      font-size: 1.5rem;\n    }\n  \n    .timeline-info-main .timeline-description {\n      font-size: 1rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .timeline-info-box-flex {\n      padding: 1rem 0.75rem;\n    }\n  \n    .patient-contact-card {\n      padding: 0.75rem;\n      font-size: 0.9rem;\n    }\n  \n    .patient-contact-card h4 {\n      font-size: 0.95rem;\n    }\n  \n    .patient-contact-card p {\n      font-size: 0.9rem;\n    }\n  \n    .timeline-info-main .timeline-title {\n      font-size: 1.25rem;\n    }\n  \n    .timeline-info-main .timeline-description {\n      font-size: 0.95rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
